import { PropsWithChildren } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

import { Logo } from '@client/toolkit';

import { PortfolioPaths } from '../../../../portfolio.router';
import { AgreementImportWizardStepper } from './agreement-import-wizard-stepper';

interface AgreementImportWizardLayoutProps {
  currentStep: number;
}

/**
 * Full-screen layout for the bulk lease-import wizard. Mirrors <c>BuildingWizardLayout</c>:
 * a fixed overlay with a close (×) button returning to the building's agreements list.
 */
export function AgreementImportWizardLayout({
  currentStep,
  children,
}: PropsWithChildren<AgreementImportWizardLayoutProps>) {
  const navigate = useNavigate();
  const { buildingId } = useParams<{ buildingId: string }>();

  const handleClose = () => {
    navigate(generatePath(PortfolioPaths.BuildingAgreements, { buildingId: buildingId ?? '' }));
  };

  return (
    <div className="fixed inset-0 z-50 bg-background flex flex-col overflow-y-auto">
      <div className="relative flex justify-center pt-8 pb-4">
        <Logo className="w-16 h-16" />
        <button
          type="button"
          aria-label="Close"
          className="absolute right-6 top-6 w-10 h-10 rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 flex items-center justify-center transition-colors"
          onClick={handleClose}
        >
          <FaTimes />
        </button>
      </div>

      <div className="px-4 py-4">
        <AgreementImportWizardStepper currentStep={currentStep} />
      </div>

      <div className="flex-1 flex flex-col items-center px-4 pb-12">
        <div className="w-full max-w-4xl">{children}</div>
      </div>
    </div>
  );
}
